import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Header from './Header';
import OverviewChart from './OverviewChart';
import LatestOperations from './LatestOperations';
import { loadDashboardCards } from '../actions';
import { setState, setForm } from '../../Payment/actions';
import { setRedirect } from '../../Transfer/actions';

class Dashboard extends Component {
    componentWillMount() {
      const { dispatch, operations } = this.props;

      // Limpar todos os campos das operações (pagamento e transferência)
      dispatch(setState({ form2: false, redirect: false, supported: true }));
      dispatch(setRedirect(false));
      dispatch(setForm({
        barcode: "",
        description: "",
        dueDate: "",
        bank: "",
        amount: "",
        protocol: ""
      }))

      if (operations.length == 0) {
        dispatch(loadDashboardCards());
      }
    }

    render() {
        return (
          <Fragment>
            <Header {...this.props.card} />
            <div className="container-fluid mt--7">
              <div className="row">
                <div className="col-xl-8 mb-5 mb-xl-0">
                  <LatestOperations />
                </div>
                <div className="col-xl-4 mb-5 mb-xl-0">
                  <OverviewChart {...this.props.card} />
                </div>
              </div>
            </div>
          </Fragment>
      );
    }
  }

  const mapStateToProps = state => {
    const { zwallet } = state;

    return {
      card: zwallet.dashboard.card,
      operations: zwallet.extract.operations
    }
  }
  
  export default connect(mapStateToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/ZWallet/Dashboard/components/Dashboard.js